import { connect } from 'react-redux';

import { getMetainf, getProjectZoneId, getRevenuePaymentFilter } from '../../reducers/analyticsApp';
import FilterModal from '../../components/common/FilterModal';
import {
  addFilterClause,
  removeFilterClause,
  removeFilter,
  setClausesConcatOperator,
  setFilterClauseOperator,
  setFilterClauseField,
  setFilterClauseValue,
} from '../../actions/revenue';
import { commonEvents } from '../../constants/event';

const mapStateToProps = (state) => {
  const filter = getRevenuePaymentFilter(state);

  return {
    btnText: 'Payment filter',
    metainf: getMetainf(state, commonEvents.PAYMENT),
    zoneId: getProjectZoneId(state),
    concatOperator: filter.concatOperator,
    clauses: filter.clauses,
  };
};

export default connect(mapStateToProps, {
  onSetClausesConcatOperator: setClausesConcatOperator,
  onAddFilterClause: addFilterClause,
  onRemoveFilterClause: removeFilterClause,
  onRemoveFilter: removeFilter,
  onSelectFilterClauseField: setFilterClauseField,
  onSelectFilterClauseOperator: setFilterClauseOperator,
  onFilterClauseValueChange: setFilterClauseValue,
})(FilterModal);
